import { NgModule } from '@angular/core';

import { LIB_CommonModule } from 'pbc.angular';

import { ZeitenMitarbeiterService } from './mitarbeiter.service';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ZeitenMitarbeiterService],
  exports: [],
})
export class ZeitenMitarbeiterModule {}
